export default __webpack_public_path__ + "static/media/woman-holds-heart-blue-space-close-up-health-care-organ-donation.aa44adec.jpg";